import React from "react";
import {
  AspectRatioContainer,
  Container
 } from "@volkswagen-onehub/components-core";
import YouTube from 'react-youtube';

type Props = {
  id: string;
};

const Video = (props: Props) => {
  const {id} = props
  const opts = {
    width: '100%',
    height: '100%',
    playerVars: {
      'autoplay': 0,
      'controls': 1,
      'rel': 0,
      'modestbranding': 1
    },
  };

  return (
    <Container horizontalAlign="center" stretchContent>
      <AspectRatioContainer ratio="16:9">
        <YouTube
          videoId={id}
          opts={opts}
        />
      </AspectRatioContainer>
    </Container>
  );
};

export default Video;
